import React from 'react';
import Modal from 'react-modal';
import './notAvailableHour.css'

interface ConfirmationModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onConfirm: () => void;
  messageCode: string;
}

const NotAvailableHour: React.FC<ConfirmationModalProps> = ({ isOpen, onRequestClose, onConfirm, messageCode }) => {
  const errorMessages: { [key: string]: string } = {
    hour_not_available: 'Esta hora ya no se encuentra disponible, por favor seleccione otro horario.',
    exceeded_max_total_hours_taken: 'Ha excedido la cantidad total de horas que puede agendar',
    exceeded_max_day_hours_taken: 'Nuestros registros indican que ya tiene una hora agendada para este día. Por favor, agende para otro día distinto.',
    invalid_patient: 'Usuario no válido',
    invalid_hour: 'Hora no válida',
    default: 'Ha ocurrido un error, por favor intente con otra hora'
  }
  
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} contentLabel="Not available hour Modal" className="notAvailableModal" overlayClassName="overlay">
      <div className="modal-not-available-header">
        <button onClick={onRequestClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
      </div>
      <div className="modal-not-available-body">
      {errorMessages[messageCode]? <p>{errorMessages[messageCode]}</p> : <p>Ha ocurrido un error, por favor intente con otra hora.</p>}
      </div>
      <div className="modal-not-available-footer">
        <button className="not-available-button" onClick={onConfirm}>Volver</button>
      </div>
    </Modal>
  );
};

export default NotAvailableHour;
